//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { OpDashboard } from "../../models/custom"
import { LocalizationHelper, EventsNames, IUserSession } from "../../helpers"
import { MenuItem } from "../common/sidebar-menu/common.sidebar-menu.directive"
import { setMenuItems } from "./dashboard.module"
import { Activity } from "../../models/common"

export const DASHBOARD_SERVICE_NAME: string = 'dashboardService'

export class DashboardService {

    constructor(private userSession: IUserSession) {

    }

    public getDestinationLevelTabs(): { text: string, key: string }[] {
        const dataSource: { text: string, key: string }[] = [{
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Operator),
            key: 'operator'
        }]

        if (this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_DISTRIBUTOR_SAVE)) {
            dataSource.push({
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Distributor),
                key: 'distributor'
            })
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_PROFILE_SAVE)) {
            dataSource.push({
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Profile),
                key: 'profile'
            })
        }

        return dataSource
    }

    /** update sidebar menu after add/remove/rename dashboard */
    public updateSidebarMenu(rootScope: ng.IRootScopeService, userSession: IUserSession, dashboard: OpDashboard, fullUpdate: boolean = false, needUpdateMenu: boolean = false): JQueryPromise<void> {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()
        if (fullUpdate) {
            MenuItem.setMenuItems(MenuItem.getMenuItems().filter((item: MenuItem) => item.state !== 'dashboard' && item.state !== 'dxdashboard'))
            setMenuItems(userSession.getDataProvider(), userSession.getLoggedOperator()).then(() => {
                rootScope.$broadcast(EventsNames.REFRESH_MENU)
                rootScope.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                deferred.resolve()
            })
        } else if (needUpdateMenu) {
            const menuItems: MenuItem[] = MenuItem.getMenuItems()
            let oneDashboard: boolean = false
            if (menuItems.filter((item: MenuItem) => item.state === 'dashboard' || item.state === 'dxdashboard').length === 1) {
                oneDashboard = true
            }
            menuItems.forEach((item: MenuItem) => {
                if (item.state == 'dashboard' || item.state == 'dxdashboard') {
                    if (oneDashboard) {
                        item.caption = dashboard.name.description
                        return
                    } else if (item.params.id == dashboard.idDashboard) {
                        item.caption = dashboard.name.description
                        return
                    }
                }
            })
            deferred.resolve()
        } else {
            deferred.resolve()
        }
        return deferred.promise()
    }
}